import { render, staticRenderFns } from "./LanguageFilterModal.vue?vue&type=template&id=bbd9f24e&"
import script from "./LanguageFilterModal.vue?vue&type=script&lang=js&"
export * from "./LanguageFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports